import React from 'react'
import { useNavigate } from 'react-router-dom'
import { API_BASE } from '../config'
import { toast } from '../lib/toastWrapper'

function safeParse(s){
  try{ return JSON.parse(s) }catch(e){ return null }
}

export default function ViewCartPage(){
  const navigate = useNavigate()
  const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null
  const raw = params ? params.get('cart') : null
  const payload = raw ? safeParse(decodeURIComponent(raw)) : null
  const items = payload?.items || []
  const amount = payload?.amount || items.reduce((s,it)=> s + ((it.unitPrice||0)*(it.quantity||1)), 0)

  const placeOrder = async () => {
    if (!items || !items.length) { toast.info('Cart is empty'); return }
    const body = { items, amount, currency: payload?.currency || 'INR' }
    try{
      toast.info('Placing order...')
      let rawAuth = null
      try{ rawAuth = localStorage.getItem('auth_user') }catch(e){}
      const headers = { 'Content-Type': 'application/json' }
      if (rawAuth) {
        const token = JSON.parse(rawAuth).token
        headers.Authorization = `Bearer ${token}`
      }
      const res = await fetch(API_BASE + '/api/orders', { method: 'POST', headers, body: JSON.stringify(body) })
      if (res.ok) {
        const data = await res.json()
        toast.success('Order placed')
        if (data && (data.orderId || data.id)) {
          const oid = data.orderId || data.id
          navigate(`/order-confirmation/${oid}`)
          return
        }
        // fallback: go to checkout
        navigate('/checkout')
      } else {
        toast.error('Could not place order')
        console.warn('Order create failed', res.status)
      }
    }catch(e){ console.error(e); toast.error('Order request failed'); navigate('/checkout') }
  }

  return (
    <section className="py-12">
      <div className="container-custom mx-auto px-6">
        <h3 className="text-2xl font-bold mb-6">View Cart</h3>
        {(!items || items.length === 0) ? (
          <div className="text-gray-600">Your cart is empty.</div>
        ) : (
          <>
            <div className="space-y-4">
              {items.map((it, i) => (
                <div key={i} className="flex items-center justify-between bg-white p-4 rounded shadow-sm">
                  <div>
                    <div className="font-semibold">{it.name}</div>
                    <div className="text-sm text-gray-600">Qty: {it.quantity || 1}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-semibold">₹{(it.unitPrice||0) * (it.quantity||1)}</div>
                    <div className="text-sm text-gray-500">₹{it.unitPrice || 0} each</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-center justify-between">
              <div className="text-lg font-semibold">Total: ₹{amount}</div>
              <div className="flex gap-3">
                <button onClick={placeOrder} className="px-4 py-2 bg-brand text-white rounded">Place order</button>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  )
}
